const BASE64_ENCODING_CHARS =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

// Use a lookup table to find the index.
const BASE64_LOOKUP = new Uint8Array(256);

for (let i = 0; i < BASE64_ENCODING_CHARS.length; i++) {
    BASE64_LOOKUP[BASE64_ENCODING_CHARS.charCodeAt(i)] = i;
}

const arrayBufferToBase64 = (arrayBuffer) => {
    let base64 = '';
    const encodings =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

    const bytes = new Uint8Array(arrayBuffer);
    const byteLength = bytes.byteLength;
    const byteRemainder = byteLength % 3;
    const mainLength = byteLength - byteRemainder;

    let a;
    let b;
    let c;
    let d;
    let chunk;

    // Main loop deals with bytes in chunks of 3
    for (let i = 0; i < mainLength; i += 3) {
        // Combine the three bytes into a single integer
        chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

        // Use bitmasks to extract 6-bit segments from the triplet
        // 16515072 = (2^6 - 1) << 18
        a = (chunk & 16515072) >> 18;
        // 258048   = (2^6 - 1) << 12
        b = (chunk & 258048) >> 12;
        // 4032     = (2^6 - 1) << 6
        c = (chunk & 4032) >> 6;
        // 63       = 2^6 - 1s
        d = chunk & 63;

        // Convert the raw binary segments to the appropriate ASCII encoding
        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder === 1) {
        chunk = bytes[mainLength];

        // 252 = (2^6 - 1) << 2
        a = (chunk & 252) >> 2;
        // Set the 4 least significant bits to zero
        // 3   = 2^2 - 1
        b = (chunk & 3) << 4;
        base64 += `${encodings[a] + encodings[b]}==`;
    } else if (byteRemainder === 2) {
        chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];
        // 64512 = (2^6 - 1) << 10
        a = (chunk & 64512) >> 10;
        // 1008  = (2^6 - 1) << 4
        b = (chunk & 1008) >> 4;
        // Set the 2 least significant bits to zero
        // 15    = 2^4 - 1
        c = (chunk & 15) << 2;

        base64 += `${encodings[a] + encodings[b] + encodings[c]}=`;
    }

    return base64;
};

const base64ToArrayBuffer = function (base64) {
    let bufferLength = base64.length * 0.75;
    const len = base64.length;
    let i;
    let p = 0;
    let encoded1;
    let encoded2;
    let encoded3;
    let encoded4;

    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }

    const arraybuffer = new ArrayBuffer(bufferLength);
    const bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE64_LOOKUP[base64.charCodeAt(i)];
        encoded2 = BASE64_LOOKUP[base64.charCodeAt(i + 1)];
        encoded3 = BASE64_LOOKUP[base64.charCodeAt(i + 2)];
        encoded4 = BASE64_LOOKUP[base64.charCodeAt(i + 3)];

        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
};

const _charCache = new Array(128);
const _charFromCodePt = String.fromCodePoint || String.fromCharCode;

const utf8ArrayToStr = (array) => {
    const buffLen = array.length;

    const result = [];

    for (let i = 0; i < buffLen; ) {
        const byte1 = array[i++];

        let codePt;

        if (byte1 <= 0x7f) {
            codePt = byte1;
        } else if (byte1 <= 0xdf) {
            codePt = ((byte1 & 0x1f) << 6) | (array[i++] & 0x3f);
        } else if (byte1 <= 0xef) {
            codePt =
                ((byte1 & 0x0f) << 12) |
                ((array[i++] & 0x3f) << 6) |
                (array[i++] & 0x3f);
        } else if (String.fromCodePoint) {
            codePt =
                ((byte1 & 0x07) << 18) |
                ((array[i++] & 0x3f) << 12) |
                ((array[i++] & 0x3f) << 6) |
                (array[i++] & 0x3f);
        } else {
            // Cannot convert four byte code points, so use "?" instead
            codePt = 63;
            i += 3;
        }

        result.push(
            _charCache[codePt] ||
                (_charCache[codePt] = _charFromCodePt(codePt)),
        );
    }

    return result.join('');
};

export default {
    arrayBufferToBase64,
    base64ToArrayBuffer,
    utf8ArrayToStr,
};
